import * as React from "react";
import { usePermissions } from 'react-admin';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ISConfig from '../../config';

const SettingPage = () => {
    const p = usePermissions();
    const isAdmin = p.loaded && p.permissions && 'user' in p.permissions && 'admin' in p.permissions && p.permissions.admin;
    let CardContentView = null;
    if (isAdmin && ISConfig.qbi) {
        CardContentView = <CardContent>Connect to quickbooks</CardContent>;
    } else {
        CardContentView = <CardContent>Settings not available</CardContent>;
    }
    
    return (
        <>
            <h3 className="text-danger px-3 px-md-0 pt-3 pt-md-0" style={{ fontFamily: 'Arial, sans-serif' }}>Settings</h3>
            <Card>
                {CardContentView}
            </Card>
        </>
    
    );
}


export default SettingPage;